<script lang="ts" setup>
import type { SupportArticle } from '@consumer/types/SupportArticle'
import { useSupport } from '@consumer/composables/support'
import type { PurchasedOrder } from '@consumer/types/serializers'
import type { BuyerOrRecipientGift } from './support'
import { articleUrl } from './support'

const { supportCategories } = useSupport()

withDefaults(defineProps<{
  article: SupportArticle
  gift?: BuyerOrRecipientGift
  order?: PurchasedOrder
  showCategory?: boolean
}>(), {  })

const category = computed(() => supportCategories.value.find(c => c.name === __props.article.category))
</script>

<template>
  <div>
    <GLink
      :href="articleUrl(article, { gift, order })"
      class="group text-black"
    >
      <h5 class="text-lg mb-1 text-primary-base group-hover:text-primary-dark">
        <template v-if="showCategory">
          {{ category?.label }} &raquo;
        </template>
        {{ article.question }}
      </h5>
    </GLink>
    <Markdown :content="article.answer" class="truncated-content"/>
  </div>
</template>

<style lang="scss">
.truncated-content {
  p:first-child {
    -webkit-box-orient: vertical;
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    -webkit-line-clamp: 3;
    overflow: hidden;

    @media screen and (min-width: 1024px) {
      -webkit-line-clamp: 2;
    }
  }

  p:first-child::after {
    content: "...";
  }

  p:only-child::after {
    content: none;
  }

  p:not(first-child) {
    display: none;
  }
}
</style>
